import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import { isLoaded as isAuthLoaded, load as loadAuth, logout } from 'redux/modules/auth';
import {Component as Progress} from "react-progress-2";
import DocumentTitle from 'react-document-title';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

const urlPrefix = __URLPREFIX__;

@connect(
	state => ({user: state.auth.identity}))
export default class App extends Component {
	static propTypes = {
		children: PropTypes.object.isRequired,
		user: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.object.isRequired,
		user: React.PropTypes.object,
		router: React.PropTypes.object
	};

	static childContextTypes = {
		location: React.PropTypes.object
	};

	getChildContext() {
		return { location: this.props.location }
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.user && nextProps.user) {
			if (nextProps.location.query.backlink) {
				this.context.router.push(nextProps.location.query.backlink);
			}
			else {
				/*const resources = ['cashbook', 'receipt', 'cashbook', 'cash', 'report', 'product', 'device', 'user'];
				const allowed = resources.filter((resource) => {
					return this.context.user.isAllowed(resource, 'select');
				});
				this.context.router.push('/' + allowed[0] ? allowed[0] : '');*/
				this.context.router.push(urlPrefix + '/');
			}
		}
		else if (this.props.user && !nextProps.user) {
			if (__MOBILE__) {
				window.location.reload();
			}
			else {
				window.location = urlPrefix + '/login';
			}
		}
	}

	handleClick(e) {
		if (__MOBILE__) {
			window.plugins.deviceFeedback.acoustic();
		}
	}

	render() {
		return (
			<DocumentTitle title="Tolex">
				<div onClick={(e) => this.handleClick(e)}>
					<Progress />
					{this.props.children}
				</div>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/App/App.js